// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XGoT","buttons":"styles_buttons__3ytHf"};